var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.37 1H2.62C1.73 1 1 1.71 1 2.59v18.83c0 .87.73 1.58 1.62 1.58h18.75c.9 0 1.63-.71 1.63-1.59V2.59C23 1.71 22.27 1 21.37 1zM7.52 19.75H4.26V9.25h3.26v10.5zM5.89 7.81C4.85 7.81 4 6.97 4 5.92c0-1.04.85-1.89 1.89-1.89s1.89.85 1.89 1.89c0 1.05-.84 1.89-1.89 1.89zm13.86 11.94h-3.26v-5.11c0-1.22-.02-2.78-1.7-2.78-1.7 0-1.96 1.33-1.96 2.7v5.19H9.57V9.25h3.13v1.43h.04c.44-.83 1.5-1.7 3.09-1.7 3.3 0 3.91 2.17 3.91 5v5.77z"
  })));
}

export default SvgSocialLinkedin;